import {MainView} from "./main-view"; 

let view = new MainView();
view.RenderujStaickiPrikaz();


// WEBPACK FOOTER //
// ./src/index.js